import { BaseDto } from "../base/baseDto.model";

export class SubtipoPropiedadDto extends BaseDto{
  public tipoPropiedad!: BaseDto
}
